export default __webpack_public_path__ + "media/images/loader/loader-life-before-birth-3.jpg";